import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {SitesService} from '../../services/sites.service';
import * as moment from 'moment';
import {DatePickerModeEnum} from '../../models/DatePickerModeEnum';
import {GetAverageScoreAccumulatorResponseDto} from '../../models/GetAverageScoreAccumulatorResponseDto';
import {AverageScoreAccumulatorsService} from '../../services/average-score-accumulators.service';
import {BaseAfterViewInitComponent} from '../base-components/after-view-init/base-after-view-init.component';
import {Subscription} from 'rxjs/Subscription';

@Component({
  selector: 'app-sites',
  templateUrl: './sites.component.html',
  styleUrls: ['./sites.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class SitesComponent extends BaseAfterViewInitComponent implements OnInit, OnDestroy {

    selectedDate: moment.Moment = null;
    selectedAverageScoreAccumulator: GetAverageScoreAccumulatorResponseDto;
    DatePickerModeEnum = DatePickerModeEnum;
    averageScoreAccumulatorsLoadedSubscription: Subscription;

    public constructor(
        private sitesService: SitesService,
        private averageScoreAccumulatorsService: AverageScoreAccumulatorsService) {
        super();
        this.averageScoreAccumulatorsLoadedSubscription = this.averageScoreAccumulatorsService.getAverageScoreAccumulatorsLoadedSubject()
            .subscribe(data => {
            this.selectedAverageScoreAccumulator = data[2];
            this.selectedDate = moment();
            this.getAllSitesReviewScores();
        });
    }

    ngOnInit(): void {}

    onDateSelected(date: moment.Moment) {
        this.selectedDate = date;
        if (this.childrenInitialized) {
            this.getAllSitesReviewScores();
        }

    }

    onAverageScoreAccumulatorSelected(averageScoreAccumulator: GetAverageScoreAccumulatorResponseDto) {
        this.selectedAverageScoreAccumulator = averageScoreAccumulator;
        this.getAllSitesReviewScores();
    }

    private getAllSitesReviewScores() {
        this.sitesService.getAllSitesIndexPagesScoresByDateAndAccumulatorId(
            this.selectedAverageScoreAccumulator.id,
            this.selectedDate.format('YYYY-MM-DD')
        );
    }

    ngOnDestroy(): void {
        this.averageScoreAccumulatorsLoadedSubscription.unsubscribe();
    }
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/components/sites/sites.component.ts